<template>
  <div>
    <b-modal v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <b-overlay :show="loading" rounded="sm">
        <form autocomplete="off" @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row container-fluid">

              <div class="form-group col-md-6">
                <label for="role"><b>Rol&nbsp;<span class="asterisk">*</span></b></label>
                <v-select v-model="form.role_option" :options="roles" class="my-custom-select" placeholder="Seleccione..."></v-select>
                <span v-if="roleValid" class="text-danger" style="font-size: 10px;"><b>El campo Rol es requerido.</b></span>
              </div>

              <div class="form-group col-md-6">
                <label for="first_name"><b>Nombre&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.first_name" type="text" class="form-control" id="first_name" name="first_name" placeholder="Nombre">
                <span v-if="first_nameValid" class="text-danger" style="font-size: 10px;"><b>El campo Nombre es requerido.</b></span>
              </div>

              <div class="form-group col-md-6">
                <label for="last_name"><b>Apellidos&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.last_name" type="text" class="form-control" id="last_name" name="last_name" placeholder="Apellidos">
                <span v-if="last_nameValid" class="text-danger" style="font-size: 10px;"><b>El campo Apellidos es requerido.</b></span>
              </div>

              <div class="form-group col-md-6">
                <label for="documenttype"><b>Tipo de Documento&nbsp;<span class="asterisk">*</span></b></label>
                <v-select v-model="form.documenttype_option" :options="documenttypes" class="my-custom-select" placeholder="Seleccione..."></v-select>
                <span v-if="documenttypeValid" class="text-danger" style="font-size: 10px;"><b>El campo Tipo de Documento es requerido.</b></span>
              </div>

              <div class="form-group col-md-6">
                <label for="document_number"><b>N.º de Documento&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.document_number" type="text" class="form-control" id="document_number" name="document_number" :placeholder="isRut ? 'Ej: 20347878-K' : 'N.º de Documento'">
                <span v-if="document_numberValid" class="text-danger" style="font-size: 10px;"><b>El campo N.º de Documento es requerido.</b></span>
                <span v-if="document_numberLength" class="text-danger" style="font-size: 10px;"><b>El N.º de Documento debe tener al menos 8 caracteres.</b></span>
                <span v-if="document_numberRut" class="text-danger" style="font-size: 10px;"><b>El N.º de Documento no es un RUT válido. Ejemplo: 20347878-K.</b></span>
                <small class="text-muted">El usuario se genera con las 3 primeras letras del nombre y este número.</small>
                <small v-if="!id" class="text-muted d-block">La contraseña inicial será este mismo número. Se cambia después desde el listado.</small>
              </div>

              <div class="form-group col-md-12">
                <label for="email"><b>Correo Electrónico&nbsp;<span class="asterisk">*</span></b></label>
                <input v-model="form.email" type="email" class="form-control" id="email" name="email" placeholder="Correo Electrónico">
                <span v-if="emailValid" class="text-danger" style="font-size: 10px;"><b>El campo Correo Electrónico es requerido.</b></span>
              </div>

              <div class="form-group col-md-6">
                <label for="phone_number"><b>Teléfono&nbsp;</b></label>
                <input v-model="form.phone_number" type="text" class="form-control" id="phone_number" name="phone_number" placeholder="Teléfono">
              </div>

              <div class="form-group col-md-6">
                <label for="movil_number"><b>Móvil&nbsp;</b></label>
                <input v-model="form.movil_number" type="text" class="form-control" id="movil_number" name="movil_number" placeholder="Móvil">
              </div>

              <!-- La contraseña no se toca aquí: al crear se deriva del documento y
                   se cambia después desde el modal de "Cambiar clave" del listado. -->
              <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
            <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
          </div>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import rut from '../../../../utils/rut';

export default {
  components: {BModal, BOverlay, vSelect},
  props: ['id', 'showModal'],
  data() {
    return {
      form: this.emptyForm(),
      roles: [],
      documenttypes: [],
      documenttypeValid: false,
      document_numberValid: false,
      document_numberLength: false,
      document_numberRut: false,
      // País configurado en el sistema; llega junto al catálogo de tipos de documento.
      country: null,
      // País cuyo documento se valida con módulo 11; lo dicta el backend.
      rutCountry: null,
      first_nameValid: false,
      last_nameValid: false,
      emailValid: false,
      roleValid: false,
      loading: false,
      textMessage: 'Crear Usuario',
    }
  },
  created() {
    this.getRoles();
    this.getDocumenttypes();
  },
  computed: {
    /**
     * ¿Toca validar RUT? Solo si el país configurado es Chile Y el tipo de documento
     * elegido lo exige. Es reactivo: cambiar el tipo enciende o apaga la validación.
     */
    isRut() {
      const abbr = this.form.documenttype_option ? this.form.documenttype_option.abbreviation : null;
      return rut.isRutContext(this.country, abbr, this.rutCountry);
    },
  },
  watch: {
    'form.document_number': function (value) {
      if (value === null || value === undefined) { return; }
      // En contexto RUT se aplica la máscara; fuera de él solo se unifica la caja,
      // para que pasaporte y DNI queden con el mismo estándar.
      const next = this.isRut ? rut.maskInput(value) : rut.normalizeDocumentCase(value);
      if (next !== value) { this.form.document_number = next; }
    },
    // Al cambiar el tipo de documento el contexto puede cambiar: se reaplica el
    // formato para que no quede un valor con la máscara del tipo anterior.
    'form.documenttype_option': function () {
      const value = this.form.document_number;
      if (!value) { return; }
      this.form.document_number = this.isRut ? rut.maskInput(value) : rut.normalizeDocumentCase(value);
    },
  },
  methods:{
    emptyForm() {
      return {
        id: null,
        user: '',
        first_name: '',
        last_name: '',
        email: '',
        document_number: '',
        phone_number: '',
        movil_number: '',
        role_option: null,
        documenttype_option: null,
      };
    },
    getRoles() {
      axios.get('/configuration/users/getRoles')
        .then(response => {
          this.roles = response.data.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getDocumenttypes() {
      axios.get('/configuration/users/getDocumenttypes')
        .then(response => {
          this.documenttypes = response.data.data;
          this.country = response.data.country; this.rutCountry = response.data.rut_country;
        })
        .catch(error => {
          console.error(error);
        });
    },
    close() {
      this.resetForm();
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.resetForm();
      this.$emit('update:showModal', false);
    },
    resetForm() {
      this.form = this.emptyForm();
      this.documenttypeValid = false;
      this.document_numberValid = false;
      this.document_numberLength = false;
      this.document_numberRut = false;
      this.first_nameValid = false;
      this.last_nameValid = false;
      this.emailValid = false;
      this.roleValid = false;
      this.textMessage = 'Crear Usuario';
    },
    getRecord() {
      this.loading = true;

      if (this.id) {
        axios.get(`/configuration/users/${this.id}`)
          .then(response => {
            this.textMessage = 'Editar Usuario';
            this.form = {
              id: response.data.id,
              user: response.data.user,
              first_name: response.data.first_name,
              last_name: response.data.last_name,
              email: response.data.email,
              document_number: response.data.document_number,
              phone_number: response.data.phone_number,
              movil_number: response.data.movil_number,
              role_option: response.data.role_option,
              documenttype_option: response.data.documenttype_option,
            };
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.resetForm();
        this.loading = false;
      }
    },
    submitForm() {
      this.documenttypeValid = false;
      this.document_numberValid = false;
      this.document_numberLength = false;
      this.document_numberRut = false;
      this.first_nameValid = false;
      this.last_nameValid = false;
      this.emailValid = false;
      this.roleValid = false;

      if (!this.form.documenttype_option) { this.documenttypeValid = true; }
      if (this.form.document_number == '' || this.form.document_number == null) { this.document_numberValid = true; }
      if (this.form.first_name == '' || this.form.first_name == null) { this.first_nameValid = true; }
      if (this.form.last_name == '' || this.form.last_name == null) { this.last_nameValid = true; }
      if (this.form.email == '' || this.form.email == null) { this.emailValid = true; }
      if (!this.form.role_option) { this.roleValid = true; }

      // Mínimo de 8: al crear, el documento es también la contraseña inicial.
      if (this.form.document_number && String(this.form.document_number).length < 8) {
        this.document_numberLength = true;
      }

      // Segunda barrera: la máscara puede no haberse aplicado si el valor se fijó por
      // código (rehidratación al editar), así que se revalida antes de enviar.
      const check = rut.isValidForSubmit(this.form.document_number, this.isRut);
      if (!check.valid) {
        this.document_numberRut = true;
        toastr.error(check.message, 'Error', { icon: 'fa fa-times-circle' });
      }

      if (this.documenttypeValid || this.document_numberValid || this.document_numberLength
          || this.document_numberRut || this.first_nameValid || this.last_nameValid
          || this.emailValid || this.roleValid) {
        return;
      }

      this.loading = true;

      // Se aplanan los v-select: el backend espera los ids, no {value,label}.
      const payload = {
        id: this.id ? this.form.id : null,
        // 'user' ya no se envía: lo deriva el backend de first_name + document_number
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        document_number: this.form.document_number,
        phone_number: this.form.phone_number,
        movil_number: this.form.movil_number,
        role_id: this.form.role_option ? this.form.role_option.value : null,
        documenttype_id: this.form.documenttype_option ? this.form.documenttype_option.value : null,
      };

      axios.post('/configuration/users', payload)
        .then(response => {
          if (response.data.status == 'error') {
            toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
            // La cuenta se crea igual aunque el correo falle; hay que avisar, porque
            // el usuario no podrá entrar hasta que alguien valide su correo.
            if (response.data.mail === 'failed') {
              toastr.warning('No se pudo enviar el correo con los datos de acceso. Valídalo desde el listado y entrégale la contraseña.', 'Aviso', { icon: 'fa fa-exclamation-circle' });
            }
            this.close();
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;
            toastr.error(Object.values(errors)[0][0], 'Error', { icon: 'fa fa-times-circle' });
          } else {
            toastr.error('No se pudo guardar el registro', 'Error', { icon: 'fa fa-times-circle' });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>
